var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"wrapper",attrs:{"gutter":15}},[_vm._l(([
      'pending',
      'wait_confirm_make_plate',
      'make_plate_rejected',
      'making_plate',
      'make_plate_completed',
      'cutting',
      'crafting',
      'craft_completed',
      'sew_rejected',
      'sewing',
      'sew_completed',
      'plate_approved',
      'quantity_audited'
    ]),function(state){return [_c('el-col',{key:state,attrs:{"md":8}},[_c('div',{staticClass:"card section"},[_c('p',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t(`productDesign.states.${state}`)))]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"item"},[_c('bean-link',{attrs:{"to":{ name: 'product_designs.index', query: { state_in: [state] } }}},[_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.data[`product_design_${state}_count`] || 0))])])],1)])])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }